module.exports = __webpack_public_path__ + "static/media/quickSearch.5db22bd8.svg";